module.exports = __webpack_public_path__ + "static/media/Feedadditives2.2829b4e0.jpeg";